import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import WarningIcon from '@mui/icons-material/Warning';
import { SvgIconProps } from '@mui/material';
import React from 'react';
import { ClaimStatus, ClaimType } from '../../interfaces/billing';

interface ClaimStatusIconProps extends Omit<SvgIconProps, 'color'> {
  status: ClaimStatus;
  source?: ClaimType;
}

export const ClaimStatusIcon: React.FC<ClaimStatusIconProps> = ({
  status,
  source,
  className: extraClassName,
  ...rest
}) => {
  const className = [
    extraClassName,
    source === ClaimType.RPM ? 'rpm-event' : 'other-event',
  ]
    .filter(Boolean)
    .join(' ');

  switch (status) {
    case ClaimStatus.UploadedWithErrors:
      return <WarningIcon {...rest} className={className} />;
    case ClaimStatus.Processed:
      return <CheckCircleIcon {...rest} className={className} />;
    case ClaimStatus.Pending:
      return <AccessTimeFilledIcon {...rest} color='warning' />;
    case ClaimStatus.Uploaded:
      return <CloudSyncIcon {...rest} className={className} />;
    default:
      return null;
  }
};
